import { Suspense } from 'react'
import { Outlet, useNavigate } from 'react-router'
import {
  FormattedMessage,
  FormattedRelativeTime,
  FormattedDate
} from 'react-intl'
import {
  getRelativeTimeProps,
  shouldUseRelativeTime
} from 'src/utils/dateUtils'
import { useConnectors } from '@hooks/useConnectors'
import ErrorBoundary from '@components/ErrorBoundary/ErrorBoundary'
import ErrorMessage from '@components/ErrorBoundary/ErrorMessage'
import ItemListSkeleton from '@components/skeletons/ItemListSkeleton/ItemListSkeleton'
import ProfileEmptyList from '../ProfileEmptyList/ProfileEmptyList'

import './ConnectorsList.css'

const ConnectorsList = () => {
  const items = useConnectors()
  const navigate = useNavigate()

  if (!items || items?.length === 0) {
    return <ProfileEmptyList type="connectors" />
  }

  return (
    <ul id="connector-item-list">
      {items?.map((item) => {
        const createdIsRecent = shouldUseRelativeTime(item.created)
        const createdProps = getRelativeTimeProps(item.created)

        return (
          <li key={item?.connectorId} className="connector-item">
            <section className="connector-item-info">
              <span className="icon icon-link" />
              <h3
                title={item?.title}
                className="connector-item-title"
                onClick={() => navigate(`info/${item?.id}`)}
              >
                <span className="ellipsis">{item?.connector}</span>
              </h3>
              <div className="connector-item-meta">
                <span className="title">{item?.title || '---'}</span>
                <span className="separator">•</span>
                <em className="meta-text created">
                  (
                  <FormattedMessage
                    id="created"
                    values={{
                      time: createdIsRecent ? (
                        <FormattedRelativeTime
                          key="connector-created-relative"
                          value={createdProps.value}
                          unit={createdProps.unit}
                        />
                      ) : (
                        <FormattedDate
                          key="connector-created-date"
                          value={item.created}
                          year="numeric"
                          month="short"
                          day="numeric"
                        />
                      )
                    }}
                  />
                  )
                </em>
              </div>
            </section>
            <section className="connector-item-actions">
              <span
                className="icon icon-dots"
                onClick={() => navigate(`info/${item.id}`)}
              />
            </section>
          </li>
        )
      })}
    </ul>
  )
}

export default function ConnectorsListWrapper() {
  return (
    <>
      <ErrorBoundary errorComponent={ErrorMessage}>
        <Suspense fallback={<ItemListSkeleton isToken />}>
          <ConnectorsList />
        </Suspense>
      </ErrorBoundary>
      <Outlet />
    </>
  )
}
